// ============================================
// HUD カラーパレット定数
// ============================================
// 仕様書に基づくホログラフィック/SF風カラー定義
// RGB タプル形式で P5.js の fill()/stroke() に直接使用可能

export const HUD_COLORS = {
    cyan: [0, 240, 255] as const,        // メインアクセント、システム表示
    green: [0, 255, 136] as const,       // シールド、正常ステータス
    yellow: [255, 204, 0] as const,      // パワーアイテム、警告
    orange: [255, 136, 0] as const,      // 自機、ホーミング
    red: [255, 51, 102] as const,        // ボスHP、危険
    magenta: [255, 0, 170] as const,     // Wave、コンボ、敵
    white: [255, 255, 255] as const,     // スコア等の数値
    panelBg: [5, 8, 12] as const,        // パネル背景
    panelBgAlpha: 217,                   // パネル背景アルファ (0.85 * 255)
    hudLine: [0, 240, 255] as const,     // グリッド、区切り線
    hudLineAlpha: 38,                    // グリッド線アルファ (0.15 * 255)
} as const;

export type HudColorTuple = readonly [number, number, number];
